import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { format } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { InputText } from "primereact/inputtext";
import { exportExcel } from "../hooks/useExportUtils";
import { Toolbar } from "primereact/toolbar";
import { Toast } from "primereact/toast";

export const ListadoBajas = () => {
  const { selectedNomina } = useOutletContext();
  const [listadoBajas, setListadoBajas] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [periodosDisponibles, setPeriodosDisponibles] = useState([]);
  const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");

  const dt = useRef(null);
  const toast = useRef(null);

  const location = useLocation();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const periodoParam = queryParams.get("periodo");
    if (periodoParam) {
      setPeriodoSeleccionado(periodoParam);
    }
  }, [location.search]);

  const getData = async () => {
    try {
      const response = await axiosPrivate.get(
        `NOM/baja-empleados?nomina=${selectedNomina.idNomina}`
      );
      const data = response.data;

      // Formatear fechaBaja a dd/MM/yyyy
      const formattedData = data.map((item) => ({
        ...item, 
        fechaBaja: item.fechaBaja
          ? format(new Date(item.fechaBaja), "dd/MM/yyyy")
          : "N/A", // Manejo de fechas nulas
        created_at: format(new Date(item.created_at), "dd/MM/yyyy HH:mm:ss"),
      }));

      setListadoBajas(formattedData);

      console.log("Bajas response:", data);
      const periodosUnicos = [
        ...new Set(data.map((item) => item.periodo)),
      ].sort((a, b) => b - a); // Orden descendente
      setPeriodosDisponibles(
        periodosUnicos.map((p) => ({ label: p.toString(), value: p }))
      );

    } catch (error) {
      console.error("Error al obtener los registros:", error);
    }
  };

  useEffect(() => {
    if (!selectedNomina) return;
    getData();
  }, [selectedNomina]);
  const columns = [
    { field: "numero", header: "Número" },
    { field: "nombre", header: "Nombre", sortable: true },
    { field: "fechaBaja", header: "Fecha baja" },
    { field: "tipoBaja", header: "Tipo" },
    { field: "observaciones", header: "Observaciones" },
    { field: "periodo", header: "Periodo" },
    { field: "usuario", header: "Usuario" },
    { field: "created_at", header: "Fecha de creación" },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable={col.sortable}
    />
  ));

  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    ),
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
  const handleBack = () => {
    navigate(-1);
  };

  const handleEdit = (empleado) => {
    console.log("Editar:", empleado);
    // Aquí podrías navegar a un formulario o abrir un modal
    navigate(`/baja-empleados/${empleado._id}`); // ajusta según tu ruta
  };

  const handleDelete = (empleado) => {
    console.log("Eliminar:", empleado);
    confirmDialog({
      message: `¿Estás seguro de eliminar el registro de "${empleado.nombre}"?`,
      header: "Confirmar para eliminar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí, eliminar",
      rejectLabel: "Cancelar",
      accept: async () => {
        try {
          await axiosPrivate.delete(`/NOM/baja-empleados/${empleado._id}`);
          toast.current.show({
            severity: "success",
            summary: "Eliminado",
            detail: `Empleado eliminado correctamente`,
            life: 3000,
          });
          getData();// Recargar empleados
        } catch (error) {
          console.error("Error al eliminar:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo eliminar el empleado",
            life: 3000,
          });
        }
      },
    });
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-info p-button-sm"
          onClick={() => handleEdit(rowData)}
          tooltip="Editar"
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger p-button-sm"
          onClick={() => handleDelete(rowData)}
          tooltip="Eliminar"
        />
      </div>
    );
  };

  const leftToolbarTemplate = () => (
    <div className="flex gap-2 items-center flex-center">
      <label htmlFor="periodo" className="whitespace-nowrap">
        Filtrar por periodo:
      </label>
      <Dropdown
        id="periodo"
        value={periodoSeleccionado}
        options={periodosDisponibles}
        onChange={(e) => setPeriodoSeleccionado(e.value)}
        placeholder="Selecciona periodo"
        className="w-15rem"
        showClear
      />
      <Button
        label="Exportar Excel"
        icon="pi pi-file-excel"
        severity="success"
        onClick={() => exportExcel(listadoBajas, "Bajas")}
      />
    </div>
  );

  const rightToolbarTemplate = () => (
    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText
        type="search"
        placeholder="Buscar..."
        value={globalFilter}
        onChange={(e) => setGlobalFilter(e.target.value)}
        className=" ml-4"
      />
    </span>
  );
  return (
    <div className="p-m-4">
      <Toast ref={toast} />
            <ConfirmDialog />
      <Card title="Solicitudes de bajas">
        <div className="mb-3 flex justify-content-between">
          <Button
            label="Regresar"
            icon="pi pi-arrow-left"
            className="p-button-secondary"
            onClick={handleBack}
          />
          <Button
            label="Agregar baja"
            icon="pi pi-list"
            className="p-button-info"
            onClick={() => navigate("/baja-empleados")}
          />
        </div>
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        />
        <DataTable
        dataKey="_id"

          value={listadoBajas}
          responsiveLayout="scroll"
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          className="p-datatable-sm"
          stripedRows
          globalFilter={globalFilter}
          globalFilterFields={[
            "numero",
            "nombre",
            "fechaBaja",
            "periodo",
            "usuario",
          ]}
        >
          {dynamicColumns}
          <Column
            body={actionBodyTemplate}
            header="Acciones"
            style={{ minWidth: "10rem" }}
          />
        </DataTable>
      </Card>
    </div>
  );
};

export default ListadoBajas;
